export default __webpack_public_path__ + "static/media/RAPDER.4df92951.png";